module.exports = __webpack_public_path__ + "img/roundedUncheckIcon.82021080.svg";